import React from "react";
import CustomStrategy from "./CustomStrategy";
import CreateStrategy from "./CreateStrategy";

function ExploreStrategy() {
  return (
    <main className="explore_strategy">
      {/* Breadcrumb */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Explore Strategy</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Explore Strategy</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Strategy Details */}
      {/* Service Style One */}
      <section
        className="container service_style_one pt_150"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        <div class="section_title">
          <h2>Discover Strategy</h2>
          <p>
            If the value of either Profit Target or Max Loss is set to 0, that
            will be considered as having no limit.
          </p>
        </div>
        <div className="container-fluid">
          {/* Tabs */}
          <div className="nav nav-tabs">
            <div className="nav-link active" data-bs-toggle="tab" href="#tab1">
              Eco Mantra Capital Strategy
            </div>
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {/* Tab 1 - Profile */}
            <div className="tab-pane fade show active" id="tab1">
              <div className="row align-items-center">
                <div className="col-lg-12 content_column">
                  <CustomStrategy />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ExploreStrategy;
